import { gql } from '@apollo/client';

export const ASSIGN_ORGANISATION = gql`
  mutation assignOrganisation($system_id: String!, $organisation_setting: OrganisationSettingInput!) {
    assignOrganisation(system_id: $system_id, organisation_setting: $organisation_setting) {
      result
    }
  }
`;
